// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useGetAllInstrumentConfigurations } from '@hooks/queries/useGetAllInstrumentConfigurations';
import { RequestState, RowNew } from '../../../../components/Table/types';
import { flattenTransfers } from '../../../../utils/flattenTransfers';
import { useCustomSort } from '../../../../utils/sortByCreatedAt';
import { useGetTransferQueries } from './useGetTransferQueries';

export const useGetTransferRows = () => {
  const transferQueries = useGetTransferQueries();

  const queryDataMap = [
    {
      query: transferQueries.transferInstructions,
      state: RequestState.Offered,
      isInterface: true,
      isThreeStep: false,
    },
    {
      query: transferQueries.executedTransfers,
      state: RequestState.Executed,
      isInterface: false,
      isThreeStep: true,
    },
    {
      query: transferQueries.rejectedTransfers,
      state: RequestState.Rejected,
      isInterface: false,
      isThreeStep: true,
    },
  ];
  const instConfigs = useGetAllInstrumentConfigurations();
  const isLoading = queryDataMap.some(({ query }) => query.isLoading);
  const rows = queryDataMap.reduce((acc: RowNew[], { query, state, isThreeStep, isInterface }) => {
    const dataArray = query.data || [];
    const newRows = flattenTransfers(dataArray, state, isThreeStep, isInterface, instConfigs.data);
    return acc.concat(newRows);
  }, []);
  const sortedByCreateTime = useCustomSort(rows);
  return {
    isLoading,
    rows: sortedByCreateTime,
  };
};
